import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=72daf5c4&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=72daf5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72daf5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72daf5c4')) {
      api.createRecord('72daf5c4', component.options)
    } else {
      api.reload('72daf5c4', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=72daf5c4&scoped=true&", function () {
      api.rerender('72daf5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40IcAaI6eSUNO/JS/comp/Voucher.vue"
export default component.exports